const action = (name) => `ADV.RETIREMENT_ASSETS_CHART.${name}`;

export const
    REQUEST_DATA = action("REQUEST_DATA"),
    requestData = (clientId, showLoading = false) => ({
        type: REQUEST_DATA,
        clientId,
        showLoading,
    }),
    RECEIVE_DATA = action("RECEIVE_DATA"),
    receiveData = (data, clientId) => ({
        type: RECEIVE_DATA,
        data,
        clientId,

    }),
    fetchData = (fpId, clientId, showLoading = false) => (dispatch) => {
        dispatch(requestData(clientId, showLoading));
        ADV.util.request({
            uri: "Consumer/GoalChart",
            data: {
                clientId,
                fpId,
            },
            showSpinner: false,
        }, true).then((resp) => {
            if (resp.success) {
                dispatch(receiveData(resp.payload.viewData, clientId));
            }
        });
    };
